import React, { useState } from "react";
import { Button, Card, CardContent, Popover } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

const useStyles = makeStyles({
  keyBoardArroy: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#80808047",
      borderRadius: "2rem",
    },
    marginLeft: 10
  },
});

const PracticasHandler = (props) => {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);

  const openPopSeguimiento = Boolean(anchorEl);
  const idPopSeguimiento = openPopSeguimiento ? "simple-popover" : undefined;

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const openPopover = (e) => {
    setAnchorEl(e.currentTarget)
    props.setOpenPracticasHandler(true)
    props.setUsuarioTurnoSeleccionado(props.item)
  }

  return (
    <React.Fragment>
      <KeyboardArrowDownIcon
        className={classes.keyBoardArroy}
        onClick={openPopover}
      />
      {props.openPracticasHandler && props.usuarioTurnoSeleccionado.idAgenda === props.item.idAgenda && (
        <Popover
          id={idPopSeguimiento}
          open={openPopSeguimiento}
          onClose={handleClosePopover}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          PaperProps={{
            style: { width: "235px" },
          }}
        >
          <Card>
            <CardContent>
              <Button
                color="primary"
                variant="contained"
                style={{ marginTop: "0.5rem", width: "12.3rem" }}
                onClick={(e) => {
                  props.onClickConsultar(props.item);
                }}
                disabled={!props.mostrarButtonConsulta}
              >
                Consultar Practicas
              </Button>
              <Button
                color="primary"
                variant="contained"
                style={{ marginTop: "1rem", width: "12.3rem" }}
                onClick={(e) => {
                  props.onClickAdd(props.item, "ADD_PRACTICA");
                }}
                disabled={!props.mostrarButtonAdd}
              >
                Agregar Practicas
              </Button>
            </CardContent>
          </Card>
        </Popover>
      )}
    </React.Fragment>
  );
};

export default PracticasHandler;
